import { FormStore, GlobalStore } from '@roc/feature-app-core';
import { action, makeObservable } from 'mobx';

const licenseForm = {
  fields: {
    licenseNumber: {
      value: '',
      error: null,
      rule: '',
    },
    licenseType: {
      value: '',
      error: null,
      rule: '',
    },
    licenseState: {
      value: '',
      error: null,
      rule: '',
    },
    nameOnLicense: {
      value: '',
      error: null,
      rule: '',
    },
    licenseIssuedDate: {
      value: '',
      error: null,
      rule: '',
      message: '',
    },
    licenseExpiryDate: {
      value: '',
      error: null,
      rule: '',
      message: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class LicenseFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super({ ...licenseForm }, globalStore);
    makeObservable(this, {
      load: action,
    });
  }

  load(data: Record<string, any>) {
    this.loadForm(data);
  }
}
